<ce-layout-basic-header headerTitle="ChargEye" class="Header">
    <div class="flex-row flex-between flex-middle">
        <span class="flex-col">
            <ce-pill class="u-spacing-sm-mr u-spacing-sm-mv" [state]="'info'" ce-pill-xs ce-pill-secondary>Beta</ce-pill>
        </span>
    </div>
</ce-layout-basic-header>
